import LayerGroup from 'ol/layer/Group';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
import { urlWMSInundaciones, formatoPNG } from './configuracion';

const  layer00393 = new TileLayer({
  title: 'Máscara 19891010',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19891010l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00393.setVisible(false);

const layer00392 = new TileLayer({
  title: 'Máscara 19900114',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19900114l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00392.setVisible(false);

const layer00391 = new TileLayer({
  title: 'Máscara 19900215',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19900215l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00391.setVisible(false);

const layer00390 = new TileLayer({
  title: 'Máscara 19900420',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19900420l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00390.setVisible(false);

const layer00389 = new TileLayer({
  title: 'Máscara 19900506',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19900506l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00389.setVisible(false);

const layer00388 = new TileLayer({
  title: 'Máscara 19900623',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19900623l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00388.setVisible(false);

const layer00387 = new TileLayer({
  title: 'Máscara 19900709',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19900709l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00387.setVisible(false);

const layer00386 = new TileLayer({
  title: 'Máscara 19900810',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19900810l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00386.setVisible(false);
 
const layer00385 = new TileLayer({
  title: 'Máscara 19900826',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19900826l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00385.setVisible(false);

export const grupoCapa01_32 = new LayerGroup({
  title: 'Ciclo Hidrológico 1989-1990',
  fold: 'close',
  layers: [layer00385, layer00386, layer00387, layer00388, layer00389, layer00390, layer00391, layer00392, layer00393]
});